<template>
  <div>
    <div class="d-flex align-center">
      <app-button
        class="expand-button"
        :class="{ 'expand-button--expanded': isRootFolderExpanded }"
        type="icon"
        size="small"
        @click="toggleExpand"
      >
        <app-material-icon name="arrow_right" />
      </app-button>

      <slot name="root" />
    </div>

    <v-expand-transition>
      <div v-show="isRootFolderExpanded" class="pl-12 pr-4">
        <slot name="children" />
      </div>
    </v-expand-transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppTreeView',
  props: {
    initiallyExpanded: {
      type: Boolean,
      required: false,
    },
  },
  data () {
    return {
      isRootFolderExpanded: this.initiallyExpanded,
    }
  },
  methods: {
    toggleExpand () {
      this.isRootFolderExpanded = !this.isRootFolderExpanded
    },
  },
})
</script>

<style scoped lang="scss">
.expand-button {
  &--expanded {
    transform: rotate(90deg);
  }
  border-radius: 50%;
  transition-duration: 280ms;
  transition-property: transform;
}
</style>
